
import React from 'react';
import {arrayOf, func, shape, string} from 'prop-types';
import {Toggle, ToggleGroup} from '@sabre/spark-react-core';
import {map} from 'lodash';


const PercentageAbsoluteTabs = ({percentageAbsoluteTabDetails, percentageAbsoluteTabOnClickHandler}) => {
    return (
        <ToggleGroup
            className={percentageAbsoluteTabDetails.className || ''}
            name={percentageAbsoluteTabDetails.toggleName}
            role='group'
            onChange={percentageAbsoluteTabOnClickHandler}
        >
            {
                map(percentageAbsoluteTabDetails.toggle, (toggleDetails, tIndex) =>
                    <Toggle
                        key={`${toggleDetails.toggleValue.replace(/\s+/ig, '-').toLowerCase()}-${tIndex}-${percentageAbsoluteTabDetails.category.replace(/\\s+/ig, '-').toLowerCase()}`}
                        defaultChecked={tIndex === 0}
                        label={toggleDetails.toggleLabel}
                        value={toggleDetails.toggleValue}
                    />
                )
            }
        </ToggleGroup>
    );
};

PercentageAbsoluteTabs.propTypes = {
    percentageAbsoluteTabDetails: shape({
        toggleName: string.isRequired,
        className: string,
        toggle: arrayOf(
            shape({
                toggleLabel: string.isRequired,
                toggleValue: string.isRequired,
                className: string
            })).isRequired,
    }),
    percentageAbsoluteTabOnClickHandler: func.isRequired
};

export default PercentageAbsoluteTabs;
